/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponUsage } from './BaseCouponUsage';
import { CourseCoupon } from './CourseCoupon';
const CourseCouponUsageParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('course')],
    ['coupon', CourseCoupon],
]), BaseCouponUsage);
export class CourseCouponUsage extends BaseCouponUsage {
    static decode(input) {
        return CourseCouponUsageParser.decode(input).map(res => new CourseCouponUsage(res));
    }
    static unsafeDecode(input) {
        return CourseCouponUsage.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseCouponUsageParser.encode(data);
    }
    static schema() {
        return CourseCouponUsageParser.schema();
    }
}
